export default __webpack_public_path__ + "static/media/frame_earth.6ed8250f.png";